

import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";
 
const BASE_URL = `${API_BASE_PATH}`;
 
// ✅ Auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};
 
// ✅ Toast error handler
const showAxiosError = (error: any, fallback: string) => {
  const detail =
    error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};
 
// ✅ Interfaces
export interface Branch {
  branch_id: string;
  branch_name: string;
  branch_address: string;
  branch_city: string;
  branch_state: string;
  branch_zipcode: string;
  branch_country: string;
  gst_number: string;
}

export interface User {
  id: string;
  name: string;
  phone_no?: string;
  email?: string;
}

export interface Contact {
  contact_id: string;
  company_name: string;
  company_mail: string;
  company_phone: string;
  company_remark: string;
  website_url: string | null;
  contact_person_name: string;
  contact_person_desigination: string;
  created_at: string;
  branch: Branch[];
  users: User;
}

 
// export interface LeadFormData {
//   website_url?: string | null;
//   lead_description?: string | null;
//   lead_status?: string | null;
//   lead_value?: string | null;
//   Currency?: string | null;
//   leadtype_id?: string | null;
//   leadsource_id?: string | null;
//   leadindustry_id?: string | null;
//   leadstage_id?: string | null;
//   user_id?: string | null;
//   product_id?: string | null;
//   product_type_id?: string | null;
//   customerPotential_id?: string | null;
//   rate_per_login?: number | null;
//   no_logins?: number | null;
//   branch_id?: string | null;
//   contact_id?: string;
//   contact_name?: string;
//   company_phone?: string;
//   contact_Company_name?: string;
//   contact_mail?: string;
//   contact_phone?: string;
// }
 
export interface Lead {
  lead_id: string;
  website_url: string | null;
  lead_description: string | null;
  lead_status: string;
  lead_value: string | null;
  Currency: string | null;

  contact: Contact | null;
  leadtype: { leadtype_id: string; leadtype_name: string };
  leadsource: { LeadSource_id: string; LeadSource_name: string; Lead_status: string };
  leadgiven_by: { leadgivenby_id: string; LeadGivenBy_name: string } | null;
  leadindustry: { LeadIndustry_id: string; LeadIndustry_name: string; Industry_status: string };
  leadstage: { LeadStage_id: string; LeadStage_name: string; LeadStage_status: string };
  users: { id: string; name: string; phone_no: string; email: string };
  products: {
    product_id: string;
    product_name: string;
    product_description: string;
    status: string;
    product_price: number;
    no_logins: number;
    rate_per_login: number;
  };
  producttype: {
    product_type_id: string;
    product_name: string;
    status: string;
    created_at: string;
  } | null;
  customertypes: {
    customerPotential_id: string;
    customerPotential_name: string;
    customerPotential_status: string;
    created_at: string;
  } | null;

  rate_per_login: number | null;
  no_logins: number | null;
  branch_id: string | null;
  client: { client_id: string };

  created_at: string;
  updated_at: string;
 leadcontributor_id: string | null; // ✅ added for lead contributor
  leadcontributor_names?: string[];
 contributor?: {
  id: string;
  name: string;
  phone_no?: string;
  email?: string;
};
  // ✅ Additional billing-related fields
  tax: number | null;
  amount: number | null;
  total_amount: number | null;
  proposal_discount: number | null;
  proposal_id: string | null;
  quotaiton_id: string | null;
  revision_id: string | null;
  client_proposal_number: string | null;
  proposal_tax_percentage: number | null;
  proposal_discount_percentage: number | null;
  cgst: number | null;
  sgst: number | null;
  igst: number | null;
  cgst_percentage: number | null;
  sgst_percentage: number | null;
  igst_percentage: number | null;
  amc: number | null;
  migrating_from?: string;
  deal_status?: string | null;
}



export interface LeadFormData {
  website_url?: string;
  lead_description?: string;
  lead_status?: string;
  lead_value?: string;
  Currency?: string;

  leadtype_id?: string;
  leadsource_id?: string;
  leadsource_name?: string;
  leadindustry_id?: string;
  leadstage_id?: string;
  user_id?: string;
  product_id?: string;
  product_type_id?: string;
  customerPotential_id?: string;
  leadowner_id?: string;
  rate_per_login?: number;
  no_logins?: number;
  branch_id?: string;
  contact_id?: string;
  leadcontributor_id ?: string; // ✅ added for distributor leads
  // Additional fields for prefill/display
  contact_name?: string;
  contact_Company_name?: string;
  company_phone?: string;
  contact_mail?: string;
  contact_phone?: string;
  leadgivenby_id: string,
  LeadGivenBy_name?: string;
  migrating_from?: string;
}

export interface CreateLeadPayload {
  leadindustry_id?: string;
  leadowner_id?: string;          // ✅ added
  leadsource_id?: string;
  leadtype_id?: string;
  product_id?: string;
  product_type_id?: string;
  customer_type_id?: string;
  customerPotential_id?: string;
  website_url?: string;
  lead_value?: string;
  Currency?: string;             // ✅ Ensure capitalization matches usage
  lead_status?: string;
  leadstage_id?: string;
  lead_description?: string;
  contact_id?: string;
  rate_per_login?: number;
  no_logins?: number;
  branch_id?: string;
  contact_name?: string;
  company_phone?: string;
  contact_Company_name?: string;
  contact_mail?: string;
  contact_phone?: string;
  migrating_from?: string;
}
// ✅ Fetch all leads
export const fetchAllLeads = async (): Promise<Lead[]> => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/leads`, {
      headers: getAuthHeaders(),
    });
    return response.data.map((item: any) => item.lead); // API wraps it as { lead, changed_by, ... }
  } catch (error) {
    showAxiosError(error, "Failed to fetch leads");
    throw error;
  }
};
 
// ✅ Fetch lead by ID
export const fetchLeadById = async (leadId: string): Promise<Lead> => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/leads/${leadId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch lead by ID");
    throw error;
  }
};
 
// ---------- Update Lead API ----------
export const updateLead = async (leadId: string, payload: LeadFormData) => {
  try {
    const formPayload = new URLSearchParams();
    Object.entries(payload).forEach(([key, value]) => {
      formPayload.append(key, value != null ? String(value) : "");
    });

    const url = `${API_BASE_PATH}/leads/${leadId}`; // ✅ plural

    const response = await axios.put(url, formPayload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...getAuthHeaders(),
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Update failed:", error);
    throw new Error(error.response?.data?.message || "Failed to update lead");
  }
};



 
// ✅ Delete lead
export const deleteLead = async (leadId: string): Promise<void> => {
  try {
    await axios.delete(`${API_BASE_PATH}/leads/${leadId}`, {
      headers: {
        ...getAuthHeaders(),
        accept: "*/*",
      },
    });
  } catch (error: any) {
    if (error?.response?.status === 403) {
      toast.error("You are not authorized to delete leads.");
    } else {
      showAxiosError(error, "Failed to delete lead");
    }
    throw error;
  }
};

export const deleteLeadsBulk = async (leadIds: string[]): Promise<void> => {
  try {
    // Convert array into comma-separated string for query param
    const idsParam = leadIds.join(",");

    const response = await axios.delete(
      `${API_BASE_PATH}/leads-bulk?lead_ids=${encodeURIComponent(idsParam)}`,
      {
        headers: {
          ...getAuthHeaders(),
          accept: "application/json",
        },
      }
    );
    toast.success(response.data?.message || "Leads deleted successfully.");
  } catch (error: any) {
    if (error?.response?.status === 403) {
      console.error("You are not authorized to delete leads.");
    } else {
      showAxiosError(error, "Failed to delete leads in bulk");
    }
    throw error;
  }
};
 
// ✅ Export all leads - PDF
export const exportLeadsPDF = async (): Promise<Blob> => {
  try {
    const res = await axios.get(`${BASE_URL}/export/pdf`, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });

    toast.success("Leads exported as PDF successfully");
    return res.data;
  }catch (error: any) {
    const errorMessage =
      error?.response?.data?.details ||
      error?.response?.data?.message ||
      "Failed to export";

    toast.error(errorMessage);
    throw error;
  }
};
 
// ✅ Export all leads - Excel
export const exportLeadsExcel = async (): Promise<Blob> => {
  try {
    const res = await axios.get(`${BASE_URL}/export/excel`, {
      responseType: "blob",
      headers: getAuthHeaders(),
    });

    toast.success("Leads exported as Excel successfully");
    return res.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.details ||
      error?.response?.data?.message ||
      "Failed to export";

    toast.error(errorMessage);
    throw error;
  }
};
 
// ✅ Export selected leads - PDF
export const exportSelectedLeadsPDF = async (
  leadIds: string[]
): Promise<Blob> => {
  try {
    const params = new URLSearchParams();
    leadIds.forEach((id) => params.append("lead_ids", id));

    const res = await axios.get(
      `${BASE_URL}/leads/export/pdf/multiple/selected/leads?${params.toString()}`,
      {
        responseType: "blob",
        headers: getAuthHeaders(),
      }
    );

    toast.success("Selected leads exported as PDF successfully");
    return res.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.details ||
      error?.response?.data?.message ||
      "Failed to export";

    toast.error(errorMessage);
    throw error;
  }
};
 
// ✅ Export selected leads - Excel
export const exportSelectedLeadsExcel = async (
  leadIds: string[]
): Promise<Blob> => {
  try {
    const params = new URLSearchParams();
    leadIds.forEach((id) => params.append("lead_ids", id));
    const res = await axios.get(
      `${BASE_URL}/leads/export/excel/multiple/selected/leads?${params.toString()}`,
      {
        responseType: "blob",
        headers: getAuthHeaders(),
      }
    );

    toast.success("Selected leads exported as Excel successfully");
    return res.data;
  }catch (error: any) {
    const errorMessage =
      error?.response?.data?.details ||
      error?.response?.data?.message ||
      "Failed to export";

    toast.error(errorMessage);
    throw error;
  }
};


export const exportLeadsReport = async ({
  leadIds,
  fields,
  format = "excel", 
}: {
  leadIds: string[];
  fields: string[];
  format?: "excel" | "pdf";
}): Promise<void> => {
  try {
    const params = new URLSearchParams();
    params.append("fields", fields.join(","));
    leadIds.forEach((id) => params.append("lead_ids", id));

    const endpoint =
      format === "pdf"
        ? `${BASE_URL}/export/leads/pdf/customized`
        : `${BASE_URL}/export/leads/excel/customized`;

    const mimeType =
      format === "pdf"
        ? "application/pdf"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const fileName = `leads_report_dynamic.${format === "pdf" ? "pdf" : "xlsx"}`;

    const response = await axios.get(`${endpoint}?${params.toString()}`, {
      headers: {
        ...getAuthHeaders(),
        Accept: mimeType,
      },
      responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }catch (error: any) {
    const errorMessage =
      error?.response?.data?.details ||
      error?.response?.data?.message ||
      "Failed to export";

    toast.error(errorMessage);
    throw error;
  }
};

export interface Company {
  contact_id: string;
  company_name: string;
  company_mail: string;
  company_phone: string;
  company_remark: string | null;
  website_url: string | null;
  contact_person_name: string;
  contact_person_desigination: string | null;
  leadsource_id: string | null;
  leadowner_id: string;
  leadgivenby_id: string;   // ✅ added
  LeadGivenBy_name?: string; // ✅ added
  leadowner_name: string;
  client_id: string;
}

export interface CompanyWithBranches {
  company: Company;
  branches: Branch[];
}

// ✅ API Function
export const getCompaniesByUserId = async (
  userId: string
): Promise<CompanyWithBranches[]> => {
  try {
    const response = await axios.get(
      `${API_BASE_PATH}/companies/by-user/${userId}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data?.data || [];
  } catch (error) {
   toast.warning("No Companies found for this user.");
   toast.warning("You are not assigned for any contacts.");
    return [];
  }
};

export const getLeadsByUserId = async (userId: string): Promise<Lead[]> => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/leads/get/by/${userId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error: any) {
    toast.warning("No leads found for this user.");
    return [];
  }
};
interface MakeCallResponse {
  status: string;
  message: string;
  call_id: string;
  uuid: string;
  lead_id: string | null;
  api_response: {
    success: {
      status: string;
      message: string;
      call_id: string;
    };
  };
}

export const makeCallToLead = async (lead_id: string) => {
  const token = localStorage.getItem("authToken") || "";
  const body = new URLSearchParams();
  body.append("lead_id", lead_id);

  const response = await axios.post(
    `${API_BASE_PATH}/knowlarity/call/lead`,
    body,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};
